import {
    SET_ANALYSIS_PROFILE,
    START_ANALYSIS_REQUEST,
    START_ANALYSIS_SUCCESS,
    START_ANALYSIS_FAILURE,
    FETCH_ANALYSIS_REQUEST,
    FETCH_ANALYSIS_SUCCESS,
    FETCH_ANALYSIS_FAILURE,
    PING_ANALYSIS_REQUEST,
    PING_ANALYSIS_SUCCESS,
    PING_ANALYSIS_FAILURE,
    CANCEL_ANALYSIS_REQUEST,
    CANCEL_ANALYSIS_SUCCESS,
    CANCEL_ANALYSIS_FAILURE,
    SET_ORDER_BY,
    SET_ORDER,
    SET_FEATURE_SELECTED,
    SET_ALL_FEATURES_SELECTED,
    CLEAR_ANALYSIS,
    EXPORT_ANALYSIS_REQUEST,
    EXPORT_ANALYSIS_SUCCESS,
    EXPORT_ANALYSIS_FAILURE,
    FETCH_ANALYSES_REQUEST,
    FETCH_ANALYSES_SUCCESS,
    FETCH_ANALYSES_FAILURE
} from './Types';

import {
    FETCH_CURRENT_PROJECT_SUCCESS, 
    SET_CURRENT_PROJECT_SUCCESS 
} from '../project/Types';

import { union, without } from 'lodash';
import { FETCH_SEARCH_REQUEST } from '../search/Types';
import { IAnalysisAction, IAnalysisReducerState } from './analysisTypes';

const defaultState = {
    isAnalysing: false,
    isPinging: false,
    isCancelling: false,
    isFetching: false,
    profile: null,
    analysis: null, // The current analysis running in the background
    orderBy: 0, // 0 = score
    order: 0, // 0 = asc, 1 = desc
    selectedFeatures: [], // List of ids of which feature analyses are selected/checked on the UI
    // A simplified list of analyses that belong to the user, used on the dashboard
    isFetchingAnalyses: false,
    analyses: null
};

export default function reducer (state: IAnalysisReducerState = defaultState, action:IAnalysisAction) {
    switch (action.type) {
        case SET_ANALYSIS_PROFILE:
            return {
                ...state,
                profile: action.id
            };
        case START_ANALYSIS_REQUEST:
            return {
                ...state,
                isAnalysing: true,
                analysis: null,
                orderBy: 0,
                order: 0,
                selectedFeatures: []
            };
        case START_ANALYSIS_SUCCESS:
            return {
                ...state,
                analysis: action.analysis,
                error: null
            };
        case START_ANALYSIS_FAILURE:
            return {
                ...state,
                isAnalysing: false,
                error: action.error
            };
        case FETCH_ANALYSIS_REQUEST:
            return {
                ...state,
                isFetching: true,
                isAnalysing: false,
                isPinging: false,
                analysis: null, // Looks cleaner clearing at moment, may be best to leave in case user cancels so previous results are retained?
                orderBy: 0,
                order: 0,
                selectedFeatures: [],
                error: null
            };
        case FETCH_ANALYSIS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isAnalysing: ['ready', 'queued', 'running'].includes(action.analysis.status),
                analysis: action.analysis,
                profile: action.analysis.weightingProfileId,
                error: null
            };
        case FETCH_ANALYSIS_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };
        case PING_ANALYSIS_REQUEST:
            return {
                ...state,
                isPinging: true,
                error: null
            };
        case PING_ANALYSIS_SUCCESS:
            return {
                ...state,
                isAnalysing: ['ready', 'queued', 'running'].includes(action.analysis.status),
                isPinging: false,
                analysis: action.analysis,
                error: (action.analysis.computedData && action.analysis.computedData.error) ? action.analysis.computedData.error : null
            };
        case PING_ANALYSIS_FAILURE:
            return {
                ...state,
                isAnalysing: false,
                isPinging: false,
                error: action.error
            };
        case CANCEL_ANALYSIS_REQUEST:
            return {
                ...state,
                isCancelling: true
            };
        case CANCEL_ANALYSIS_SUCCESS:
            return {
                ...state,
                isAnalysing: false,
                isPinging: false,
                isCancelling: false,
                analysis: null,
                orderBy: 0,
                order: 0,
                selectedFeatures: []
            };
        case CANCEL_ANALYSIS_FAILURE:
            return {
                ...state,
                isCancelling: false,
                error: action.error
            };
        case SET_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case SET_ORDER:
            return {
                ...state,
                order: action.order
            };
        case SET_FEATURE_SELECTED:
            return {
                ...state,
                selectedFeatures: action.isSelected ?
                    union(state.selectedFeatures, [action.id]) :
                    without(state.selectedFeatures, action.id)
            };
        case SET_ALL_FEATURES_SELECTED:
            return {
                ...state,
                selectedFeatures: (action.isSelected && state.analysis) ?
                    state.analysis.featureAnalyses.map(e => e.id) :
                    []
            };
        case CLEAR_ANALYSIS:
            // console.log("This should be replaced with better logic to ensure that an analysis isn't lost while in progress")
            return {
                ...defaultState,
                profile: state.profile
            };
        case EXPORT_ANALYSIS_REQUEST:
            return {
                ...state,
                isExporting: true,
                error: null
            };
        case EXPORT_ANALYSIS_SUCCESS:
            return {
                ...state,
                isExporting: false,
                error: null
            };
        case EXPORT_ANALYSIS_FAILURE:
            return {
                ...state,
                isExporting: false,
                error: action.error
            };
        case FETCH_ANALYSES_REQUEST:
            return {
                ...state,
                isFetchingAnalyses: true,
                error: null
            };
        case FETCH_ANALYSES_SUCCESS:
            return {
                ...state,
                isFetchingAnalyses: false,
                analyses: action.analyses,
                error: null
            };
        case FETCH_ANALYSES_FAILURE:
            return {
                ...state,
                isFetchingAnalyses: false,
                error: action.error
            };
        // When the project is changed then clear the analyses
        case FETCH_CURRENT_PROJECT_SUCCESS:
        case SET_CURRENT_PROJECT_SUCCESS: {
            return {
                ...state,
                analysis: null,
                analyses: [],
                selectedFeatures: []
            };
        }
        // When a search is fetched, clear analysis as may not link
        case FETCH_SEARCH_REQUEST:
            return {
                analysis: null,
                selectedFeatures: []
            };
        default:
            return state;
    }
}
